import { render, staticRenderFns } from "./ProviderProfile.vue?vue&type=template&id=39c8ac3a&"
import script from "./ProviderProfile.vue?vue&type=script&lang=js&"
export * from "./ProviderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports